import { render, staticRenderFns } from "./TipoServicoLegado02.vue?vue&type=template&id=311a7a99&"
import script from "./TipoServicoLegado02.vue?vue&type=script&lang=js&"
export * from "./TipoServicoLegado02.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports